module.exports = __webpack_public_path__ + "static/media/biGame.21adcd98.png";